__turbopack_context__.v({
  "svg": "Check-module__cVpX0a__svg",
});
